<template>
  <div :class="classes" v-loading="loading">
     <pt-page-title title="直播列表" :isSearch="true" @search="search" :searchKey="keyword" @emptySearch="emptySearch">
      <el-button slot="before-left" type="primary" @click="toCreate">新建直播</el-button>
    </pt-page-title>
    <pt-page-factor-filter :labels="filterLabel" v-model="params" isQueryRouter @Filter="Filter" ref="filter">
      <template>
        <el-button type="primary" @click="Filter()">筛选</el-button>
        <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
      </template>
    </pt-page-factor-filter>
     <pt-live-list-table :tableLabels="tableLabels" :isFromRouter="isFromRouter" ref="table" :paramsData="paramsData">
       <el-table-column label="第三方链接">
        <template slot-scope="scope">
          <pt-copy-button type="text" :copyContent="scope.row.link" text="点击复制"></pt-copy-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="goEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="goDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </pt-live-list-table>
  </div>
</template>

<script>
import ptLiveListTable from './pt-live-list-table/withData'
import {
  emptyObject
} from '@/utils/lifebankUtils'
import { liveFilterLabel, liveTableLabels } from '../famous-doctor-hall'
// 组件class前缀
const prefixCls = 'pt-live-list'

export default {
  name: 'pt-live-list',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    ptLiveListTable
  },
  data () {
    return {
      keyword: '',
      params: {},
      paramsData: {},
      filterLabel: liveFilterLabel,
      tableLabels: liveTableLabels,
      isFromRouter: false,
      loading: false
    }
  },
  methods: {
    goDelete (row) {
      this.$confirm(`确定要删除直播：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deteleLive', row.id).then(data => {
          this.$refs.table.load()
          this.$message.success('删除成功！')
          this.loading = false
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    },
    search (val) {
      this.keyword = val
      this.isFromRouter = false
      emptyObject(this.queryParams)
      emptyObject(this.params)
      this.paramsData = {
        keyword: val
      }
    },
    emptySearch () {
      this.keyword = null
      this.$delete(this.paramsData, 'keyword')
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      for (var key in this.params) {
        if (!this.params[key]) {
          this.$delete(this.params, key)
        }
        if (key === 'startTime') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      this.paramsData = {
        ...this.params
      }
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      emptyObject(this.params)
      this.Filter()
    },
    toCreate () {
      this.$router.push('/live-list/live-list-form/false/0')
    },
    goEdit (val) {
      this.$router.push('/live-list/live-list-form/true/' + val.id)
    },
    goDetail (val) {
      this.$router.push('/live-list-detail/' + val.id)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
